'use strict';

import { Entity } from '../Entity';

export class UserEmailBatch extends Entity {
  protected batchId;
  protected batchDate;
  protected batchStatus;
  protected batchFromEmail;
  protected batchFromName;
  protected batchSubject;
  protected batchAttachments;
  protected batchCount;
  protected batchReplyTo;

  constructor() {
    super();
  }

  public hydrate(data: any) {
    this.batchId = data.batchId;
    this.batchStatus = data.batchStatus;
    this.batchFromEmail = data.batchFromEmail;
    this.batchFromName = data.batchFromName;
    this.batchSubject = data.batchSubject;
    this.batchAttachments = data.batchAttachments;
    this.batchCount = data.batchCount;
    this.batchReplyTo = data.batchReplyTo;

    if (data.batchDate) {
      const batchDate = data.batchDate.date.split(' ')[0].split('-');
      this.batchDate = batchDate[1] + '/' + batchDate[2] + '/' + batchDate[0];
    }
  }

  public getBatchId() {
    return this.batchId;
  }

  public getBatchDate() {
    return this.batchDate;
  }

  public getBatchStatus() {
    return this.batchStatus;
  }

  public getBatchFromEmail() {
    return this.batchFromEmail;
  }

  public getBatchFromName() {
    return this.batchFromName;
  }

  public getBatchSubject() {
    return this.batchSubject;
  }

  public getBatchAttachments() {
    return this.batchAttachments;
  }

  public getBatchCount() {
    return this.batchCount;
  }

  public getBatchReplyTo() {
    return this.batchReplyTo;
  }
}
